// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2IbAg{margin-right:-1.6rem}html[dir=ltr] ._27RLb{margin-right:3.2rem}html[dir=rtl] ._27RLb{margin-left:3.2rem}.zhuhL{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#fff;border-radius:50%;height:24px;height:2.4rem;justify-content:center;overflow:hidden;width:24px;width:2.4rem}.haUNH{height:100%;-o-object-fit:cover;object-fit:cover;width:auto}._15sqi{color:#fff}._15sqi,._2wkIb{font-size:12px;font-size:1.2rem;font-weight:700;line-height:16px;line-height:1.6rem}._2wkIb{color:#0a385a;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;text-align:left}._36JUp{min-height:50px;min-width:105px}", ""]);
// Exports
exports.locals = {
	"header__rightSide": "_2IbAg",
	"element": "_27RLb",
	"clinicLogo": "zhuhL",
	"clinicLogo__img": "haUNH",
	"clinicLogo__initials": "_15sqi",
	"clinicLogo__label": "_2wkIb",
	"ascensiaLogo": "_36JUp"
};
module.exports = exports;
